<template>
    <!--
        latestImageIdとunsavedPuriCountはこのheader,footerタイプの組み合わせだと必要ないが
        BaseLayoutの設計上必須propsにしているので、ダミーの値を渡している
    -->
    <base-layout
        :header-type="headerType.LOGOONLY"
        :footer-type="footerType.COPYRIGHTONLY"
        latest-image-id="dummy"
        unsaved-puri-count="0"
    >
        <div class="c-jhs-free-entry-duplicate">
            <jhs-free-heading/>

            <section class="l-section">
                <heading-bg title="申し込みできません"/>
                <div class="l-element">
                    <p class="m-text-normal is-primary is-text-center is-text-bold is-mgb0">すでに申込済みです</p>
                </div>
                <div class="l-element">
                    <p class="m-text-normal is-mgb0">
                        審査中または審査結果をお届け済みです。<br>
                        審査結果は下記の方法でお届けしております。
                    </p>
                </div>

                <div class="l-element">
                    <p class="m-text-normal is-text-bold is-light is-mgb4">1.<span class="is-light is-mgl4">メールでのご連絡</span></p>
                    <p class="m-text-normal is-light is-mgb0">お申し込み時に入力されたメールアドレスへ送信されます。</p>
                </div>
                <div class="l-element">
                    <p class="m-text-normal is-text-bold is-light is-mgb4">2.<span class="is-light is-mgl4">ピクトリンク内でのご連絡</span></p>
                    <p class="m-text-normal is-light is-mgb0">お申し込み時のアカウントでログイン状態の場合にサイトとアプリに表示されます。</p>
                </div>

                <div class="l-element">
                    <list-text :comments="true" class="is-full-width">
                        <li class="m-list-text-item">
                            審査結果の確認方法は<link-text class="is-caution" :link="this.help1852" text="こちら" data-jest="help-1852-link"/>をご確認ください。
                        </li>
                        <li class="m-list-text-item is-mgb8">
                            申込みから<span class="is-primary">5日</span>以上経っても審査結果がご確認いただけない場合は、お手数ですが下記までお問い合わせください。
                        </li>
                    </list-text>
                    <p class="m-text-comments is-light">※審査には5日以上かかる場合もございます。</p>
                </div>

                <heading-plain text="お問い合わせ" />
                <div class="l-element">
                    <Table>
                        <tbody>
                        <tr>
                            <th class="m-table-plain-title"><p class="m-text-comments">お問い合わせ先</p></th>
                        </tr>
                        <tr>
                            <td class="m-table-plain-content">
                                <p class="m-text-comments is-light">ピクトリンク　カスタマーセンター</p>
                            </td>
                        </tr>
                        <tr>
                            <th class="m-table-plain-title"><p class="m-text-comments">お問い合わせフォーム</p></th>
                        </tr>
                        <tr>
                            <td class="m-table-plain-content">
                                <p class="m-text-comments is-light">
                                    <link-text :link="this.inquiryUrl" text="https://sp.pictlink.com/web/common/inquiry/input" data-jest="inquiry-link"/>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <th class="m-table-plain-title"><p class="m-text-comments">受付時間</p></th>
                        </tr>
                        <tr>
                            <td class="m-table-plain-content">
                                <p class="m-text-comments is-light">午前9：30～午後5：00（土・日・祝日・弊社休業日を除く）</p>
                            </td>
                        </tr>
                        </tbody>
                    </Table>
                </div>
            </section>

            <div class="l-element">
                <btn @click="onClickTopButton" text="ピクトリンクTOPへ" :priority="cssPriority.SECONDARY" data-jest="top-link"/>
            </div>
        </div>
    </base-layout>
</template>

<script>
import BaseLayout from "../../templates/BaseLayout.vue";
import JhsFreeHeading from "../../molecules/JhsFreeHeading.vue";
import HeadingBg from "../../atoms/HeadingBg.vue";
import HeadingPlain from "../../atoms/HeadingPlain.vue";
import ListText from "../../atoms/ListText.vue";
import Btn from "../../atoms/Btn.vue"
import Table from "../../atoms/Table.vue"
import LinkText from "../../atoms/LinkText.vue";
import * as metaInformationUtil from "../../../util/metaInformationUtil.js";
import * as urlUtil from "../../../util/UrlUtil.js";
import {cssPriority} from "../../../view-model/enum/CSSPriority";
import {headerType} from "../../../view-model/enum/HeaderType";
import {footerType} from "../../../view-model/enum/FooterType";
import {mapGetters} from "vuex";
import {moveToTopPage} from "./common/jhsFreeLinkUtils";

export default {
    name: "JhsFreeErrorEntryDuplicate",
    components: {BaseLayout, JhsFreeHeading, HeadingBg, HeadingPlain, ListText, Btn, Table, LinkText},
    props: {
        /**
         * titleタグ
         */
        title: {
            type: String,
            required: true
        },
        /**
         * meta description
         */
        description: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            headerType: headerType,
            footerType: footerType,
            cssPriority: cssPriority,
            inquiryUrl: urlUtil.servletUrlUtil.inquiryInputUrl(''),
            help1852: urlUtil.helpUrlUtil.helpDetailUrl(1852),
        }
    },
    computed: {
      ...mapGetters('AccountStoreV2', [
        'isAppli'
      ]),
    },
    methods: {
        setTitleAndDesc() {
            metaInformationUtil.setTitleAndDescription(this.title, this.description)
        },
        onClickTopButton(){
            moveToTopPage(this.isAppli,'ピクトリンクTOPへ')
        }
    },
    mounted() {
        this.setTitleAndDesc()
    }
}
</script>

<style scoped lang="scss">

.c-jhs-free-entry-duplicate{
    .m-heading-plain{
        font-size: 1rem;
        padding-bottom: 1px;
    }
    .is-mgl4 {
        margin-left: 4px!important;
    }
}

</style>
